import React,{useEffect,useRef} from "freact"

export default function About() {
  const headerRef = useRef(null)
  const introRef = useRef(null)
  
  const onScroll = ()=>{
    const elementTop = introRef.current.getBoundingClientRect().top;
    if (elementTop <20) {
      headerRef.current.classList.remove("hidden")
      return
    }
    headerRef.current.classList.add("hidden")
  }


  useEffect(()=>{
    window.addEventListener("scroll",onScroll)
    return ()=> window.removeEventListener("scroll",onScroll)
    
  },[])


  return (
    <div className="bg-white py-12">
      <div ref={headerRef} className="fixed text-white inset-x-0 top-0 hidden
        bg-gradient-to-r from-yellow-500 via-pink-500 to-sky-400 p-2 text-center font-semibold">
        Faye <span className="text-slate-700">Wang</span>
      </div>

      <div className="md:w-[80%] lg:w-[950px] 2xl:w-[1000px] md:mx-auto flex flex-col space-y-24 px-3 sm:px-8">
        <div ref={introRef} className="text-5xl text-slate-700 text-left font-semibold">
          Faye
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-sky-500"> Wang</span>
          <span className="text-white leading-[1.2]" role="img" aria-label="woman technologist">👩🏻‍💻</span>
        </div>

        <div className="intro text-slate-800 sm:w-[70%] leading-[1.75em] space-y-4">
            <div className="text-xl font-semibold">
              Hi there! I'm Faye, a skilled Full Stack Developer and the author of <a href="https://freact.vercel.app/">Freact</a> and <a href="https://github.com/wangfei20/fredux/">Fredux</a>.
            </div>
            <div className="font-light text-lg">
            I am passionately in love with JavaScript and NodeJS. This adoration and obsession continuously drive me to explore and uncover their internal mysteries. My entire journey as a JS developer has been a unique exploration of open-source software. From Template Engine to Promise, from Express to Hexo, from React to NextJS, nearly every significant framework and tool that I love, I dive into reverse engineering after experiencing them. I never join any open-source projects intending to leave my name on them, as that simply cannot gratify my immense curiosity. The only way I can be satisfied is to recreate the entire framework from scratch, all by myself.
            </div>

          </div>

        <div className="sm:mx-[-10px] projects text-[7vw] md:text-[5vw] 2xl:text-[3vw] bg-clip-text text-transparent
                        bg-gradient-to-r from-yellow-500 via-pink-500 to-sky-400
                        text-center sm:text-left font-semibold flex flex-wrap">
          <div>
            <a href="https://freact.vercel.app/">
              Freact, 
            </a>
            <a className="text-slate-800" href="https://github.com/wangfei20/fredux">
              FRedux, 
            </a>
            <a href="https://github.com/wangfei20/WhatIsNext">
              FNextJS
            </a>

          </div>

          <div>
            <a className="text-slate-800" href="https://github.com/wangfei20/Freact/blob/master/src/router.js">
              FRouter
            </a>
            <span className="text-slate-800">,</span>
            <a href="https://github.com/wangfei20/Freact/blob/master/demo/components/CSSTransition.js">
              CSSTransition
            </a>
          </div>



          <div>
            <a href="https://github.com/wangfei20/nodejs-lab/blob/master/express/pipeline.js">
              FExpressJS
            </a>
            <span className="text-slate-800">,</span>
            <a href="https://github.com/wangfei20/nodejs-lab/blob/master/express/bodyParser.js" className="text-slate-800">
              BodyParser
            </a>
          </div>

          <div>
            <a className="text-slate-800" href="https://github.com/wangfei20/nodejs-lab/blob/master/hexo/hexo.js">FexoJS</a>
            <span className="text-slate-800">,</span>
            <a href="https://github.com/wangfei20/nodejs-lab/blob/master/promise.js">FPromise</a>
            <span className="text-slate-800">,</span>
            <a href="https://github.com/wangfei20/nodejs-lab/blob/master/fei.js">FJS</a>
            
          </div>
          
        </div>

        <div className="flex flex-col sm:flex-row gap-y-2 place-content-between items-center py-4 text-black mt-24">
          {/* <div>© 2024 <span className="white-space">Fiona Wang</span></div> */}
          
          <div className="text-sm mr-6 text-italics white-space">© 2024. <a className="font-bold" href="https://freact.vercel.app/">Powered by Freact.</a></div>
          
          <div className="footer-contacts flex">
            <a href="https://github.com/wangfei20" target="_blank" >
              Github
            </a>
            <a href="https://www.linkedin.com/in/fionacodes/" target="_blank" >
              LinkedIn
            </a>
            <a href="mailto://faye.lia.wang@gmail.com" target="_blank" >
              Email
            </a>
          </div>
        </div>

      </div>

    </div>
  )
}
/*I'm an experienced programmer who's crazy about React.js and Next.js.
            <br/>I also wrote Freact, a minimal and powerful React-Like Library, and many more.*/
